import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Spinner,
  Table,
} from 'react-bootstrap';
import { updateSelectedComponentAction } from '../../../actions/instances/components';
import CreateSelectModal from '../../Modals/CreateSelectModal/CreateSelectModal';
import CreateComponentModal from '../../Modals/Content/Components/CreateComponentModal/CreateComponentModal';
import SelectComponentModal from '../../Modals/Content/Components/SelectComponentModal/SelectComponentModal';
import './ComponentsList.scss';

const ComponentsList = ({
  components,
  onItemAdded,
  isLoading,
  cityId,
  dynastyId,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [productsInlineEditingShown, setProductsInlineEditingShown] = useState(false);
  const navigateToComponent = (component) => {
    dispatch(updateSelectedComponentAction(component));
    history.push('/instances/building-components/view');
  };
  const itemSelected = (component) => {
    if (onItemAdded) {
      onItemAdded(component);
    }
    setProductsInlineEditingShown(false);
  };
  return (
    <div className="row mt-5">
      <div className="col-md-12 d-flex justify-content-between">
        <h6 className="ps-0">Components</h6>
        <p>
          <CreateSelectModal
            title="Create or select a component"
            createView={(
              <CreateComponentModal
                onItemCreated={comp => itemSelected(comp)}
                cityId={cityId}
                dynastyId={dynastyId}
              />
            )}
            selectView={<SelectComponentModal onItemSelected={comp => itemSelected(comp)} />}
            onRequestClose={() => setProductsInlineEditingShown(false)}
            isShown={productsInlineEditingShown}
          />
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a href="#" onClick={() => setProductsInlineEditingShown(true)}>
            Link to Component
          </a>
        </p>
      </div>
      <div className="col-md-12">
        <Table striped bordered hover>
          <colgroup>
            <col width="10%" />
            <col width="70%" />
            <col width="20%" />
          </colgroup>
          <thead>
            <tr>
              <th />
              <th>Name</th>
              <th>Dynasty</th>
            </tr>
          </thead>
          <tbody>
            {!isLoading && components && components.map(comp => (
              <tr>
                <td>
                  {comp.images.length > 0 ? (
                    <img alt={comp.name} src={comp.images[0].url} height={50} width={50} style={{ objectFit: 'cover' }} />
                  ) : (
                    <img alt={comp.name} src="/images/default.jpg" height={50} width={50} style={{ objectFit: 'cover' }} />
                  )}
                </td>
                {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                <td onClick={() => navigateToComponent(comp)}>
                  {`${comp.name} [${comp.code}]`}
                </td>
                {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                <td onClick={() => history.push('/dynasties')}>
                  {`${comp.dynasty.name} [${comp.dynasty.code}]`}
                </td>
              </tr>
            ))}
            {!isLoading && (components === undefined || components.length === 0) && (
            <tr className="text-center">
              <td colSpan={3}>No Components were added to this building</td>
            </tr>
            )}
            {isLoading && (
            <tr>
              <td colSpan={3} className="text-center">
                <Spinner />
              </td>
            </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

ComponentsList.propTypes = {
  components: PropTypes.array.isRequired,
  onItemAdded: PropTypes.func,
  isLoading: PropTypes.bool,
  cityId: PropTypes.number,
  dynastyId: PropTypes.number,
};

ComponentsList.defaultProps = {
  onItemAdded: undefined,
  isLoading: false,
  cityId: undefined,
  dynastyId: undefined,
};

export default ComponentsList;
